import React from 'react';
import { format, addDays, isSameDay } from 'date-fns';
import { ja } from 'date-fns/locale';
import TimeSlots from './TimeSlots';
import RoomColumn from './RoomColumn';
import { ROOMS } from '../../utils/constants';
import '../../styles/calendar.css';

/**
 * カレンダーグリッドコンポーネント（週表示スタイル）
 */
const CalendarGrid = ({
  weekDates,
  reservations,
  onReservationClick,
  onEmptySlotClick,
  onReservationDrop,
  viewMode = 'workweek',
  gridRef,
  newlyCreatedIds = [],
  slideDirection = null,
}) => {
  /**
   * 指定日・指定会議室の予約を抽出（G+Bは除外）
   */
  const getReservationsForDayAndRoom = (date, roomType) => {
    return reservations.filter(
      (reservation) =>
        isSameDay(new Date(reservation.start_datetime), date) &&
        reservation.room_type === roomType
    );
  };

  /**
   * 指定日のG+B予約を抽出
   */
  const getGBReservationsForDay = (date) => {
    return reservations.filter(
      (reservation) =>
        isSameDay(new Date(reservation.start_datetime), date) &&
        reservation.room_type === 'GB'
    );
  };

  // スライドアニメーションクラスを決定
  const slideClass = slideDirection === 'left' ? 'slide-from-left' : slideDirection === 'right' ? 'slide-from-right' : '';

  return (
    <div ref={gridRef} className="calendar-grid-container">
      <div className={`calendar-grid weekly ${viewMode === 'fullweek' ? 'fullweek' : 'workweek'} ${slideClass}`}>
        {/* 時間軸 */}
        <div className="time-column">
          <div className="time-header weekly" style={{ height: '80px' }}>
            時刻
          </div>
          <TimeSlots />
        </div>

        {/* 週の各日に対して会議室G、Bの列を生成 */}
        {weekDates.map((date) => (
          <div key={date.toString()} className="day-group">
            {/* 日付ヘッダー（2列に跨る） */}
            <div className="day-header">
              {format(date, 'M/d(E)', { locale: ja })}
            </div>

            {/* 会議室G列とB列のコンテナ */}
            <div className="day-rooms">
              {/* 会議室G列 */}
              <RoomColumn
                roomType="G"
                roomName={ROOMS.G.name}
                date={date}
                dateLabel=""
                reservations={getReservationsForDayAndRoom(date, 'G')}
                gbReservations={getGBReservationsForDay(date)}
                onReservationClick={onReservationClick}
                onEmptySlotClick={onEmptySlotClick}
                onReservationDrop={onReservationDrop}
                isFirstColumn={true}
                newlyCreatedIds={newlyCreatedIds}
              />

              {/* 会議室B列 */}
              <RoomColumn
                roomType="B"
                roomName={ROOMS.B.name}
                date={date}
                dateLabel=""
                reservations={getReservationsForDayAndRoom(date, 'B')}
                gbReservations={[]} // G+BはG列で処理するのでB列では空
                onReservationClick={onReservationClick}
                onEmptySlotClick={onEmptySlotClick}
                onReservationDrop={onReservationDrop}
                isFirstColumn={false}
                newlyCreatedIds={newlyCreatedIds}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarGrid;
